import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id C810823C-6678-43F7-8DBB-5D32F503BC59
 * name mortar-pestle
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mortar-pestle.svg
 * tags
 */
export const MortarPestleIcon = createSvgIcon(<><path d="M21 7L19 13L21 19V21H3V19L5 13L3 7V5H15.7L17.2 1L19.5 1.8L18.3 5H21V7Z" /></>, 'MortarPestleIcon');
export default MortarPestleIcon